import React from "react";
import { TabState, UpdateFileOptions } from "@/apps/forge/states/tabs/TabState";
import { EditorFile } from "@/apps/forge/EditorFile";
import * as KotOR from "@/apps/forge/KotOR";
import { snapshotGff } from "@/apps/forge/helpers/gffUndoSnapshot";
import { beginUtxFileUpdate, finishUtxUndoApply } from "@/apps/forge/helpers/UTxEditorHelpers";
import BaseTabStateOptions from "@/apps/forge/interfaces/BaseTabStateOptions";
import { TabUTMEditor } from "@/apps/forge/components/tabs/tab-utm-editor/TabUTMEditor";
import { ForgeStore, StoreItemEntry } from "@/apps/forge/module-editor/ForgeStore";

export class TabUTMEditorState extends TabState {
  tabName: string = `UTM`;
  store: ForgeStore = new ForgeStore();
  
  get blueprint(): KotOR.GFFObject {
    return this.store.blueprint;
  }

  get itemList(): StoreItemEntry[] {
    return this.store.itemList;
  }

  set itemList(value: StoreItemEntry[]) {
    this.store.itemList = value;
  }

  constructor(options: BaseTabStateOptions = {}){
    super(options);

    this.setContentView(<TabUTMEditor tab={this}></TabUTMEditor>);
    this.openFile();
    this.saveTypes = [
      {
        description: 'Odyssey Store Blueprint',
        accept: {
          'application/octet-stream': ['.utm']
        }
      }
    ];
  }

  public openFile(file?: EditorFile){
    return new Promise<KotOR.GFFObject>( (resolve, reject) => {
      if(!file && this.file instanceof EditorFile){
        file = this.file;
      }
  
      if(file instanceof EditorFile){
        if(this.file != file) this.file = file;
        this.file.isBlueprint = true;
        this.tabName = this.file.getFilename();
  
        file.readFile().then( (response) => {
          this.store = new ForgeStore(response.buffer, file.resref);
          this.clearUndoHistory();
          this.processEventListener('onEditorFileLoad', [this]);
          resolve(this.blueprint);
        });
      }
    });
  }

  show(): void {
    super.show();
  }

  hide(): void {
    super.hide();
  }

  animate(delta: number = 0){
    //todo
  }

  async getExportBuffer(resref?: string, ext?: string): Promise<Uint8Array> {
    if(!!resref && ext == 'utm'){
      this.store.templateResRef = resref;
      this.store.resref = resref;
      this.updateFile({ skipHistory: true });
      return this.store.blueprint.getExportBuffer();
    }
    return super.getExportBuffer(resref, ext);
  }

  updateFile(options?: UpdateFileOptions){
    beginUtxFileUpdate(this, options);
    this.store.exportToBlueprint();
    if(this.file){
      this.file.buffer = this.store.blueprint.getExportBuffer();
      this.processEventListener('onEditorFileChange', [this]);
    }
  }

  protected captureUndoState(): Uint8Array | undefined {
    return snapshotGff(this.blueprint);
  }

  protected applyUndoState(state: Uint8Array): void {
    this.store = new ForgeStore(state, this.file?.resref);
    finishUtxUndoApply(this);
  }
}

